import script from "./authSuccess.vue?vue&type=script&lang=ts&setup=true"
export * from "./authSuccess.vue?vue&type=script&lang=ts&setup=true"

import "./authSuccess.vue?vue&type=style&index=0&id=175f6340&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-175f6340"]])

export default __exports__